<div matDialogTitle class="edit-work-order__header">
  <h1 class="edit-work-order__header__title" i18n="@@S_EDIT_WORKORDER">Edit Work Order</h1>
  <button mat-icon-button matDialogClose class="edit-work-order__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="edit-work-order__content">
  <div class="edit-work-order-general-error" [class.edit-work-order-general-error--show]="hasError$ | async">
    <mat-icon class="edit-work-order-general-error__icon mat-icon-size-sm" svgIcon="ds-ic-important"></mat-icon>
    <span i18n="@@S_DEVICESTATUS_ACTION_ERROR">There was an error processing your request, please try again.</span>
  </div>
  <form [formGroup]="form" novalidate>
    <h2 i18n="@@S_CUSTOMERDETAILS">CUSTOMER DETAILS</h2>
    <div class="edit-work-order__fields-group">
      <div class="edit-work-order__column">
        <div
          class="edit-work-order__control edit-work-order__control-location"
          [class.form-control--invalid]="form.get('location').invalid && isSubmitted"
        >
          <label i18n="@@S_LOCATION">Location</label>
          <fm-search-light-form
            [entityTypes]="searchLightTypes"
            formControlName="location"
            [initialDisplayValue]="initialLocationValue$ | async"
            minCharsMessage="Type at least {{ 3 }} characters"
            i18n-minCharsMessage="@@S_TYPE_LEAST_CHARACTERS"
            noResultMessage="Your search did not return any results"
            i18n-noResultMessage="@@S_SEARCH_NOT_RETURN_RESULTS"
            [resultsWidth]="480"
            (searchTextChange)="onLocationSearchTextChange()"
          ></fm-search-light-form>
          <span *ngIf="form.get('location').invalid && isSubmitted" class="edit-work-order__error" i18n="@@S_WORKORDEREDIT_LOCATION"
            >Work order location required.</span
          >
        </div>
        <fm-google-maps-light [coordinates]="mapLocation"></fm-google-maps-light>
      </div>
      <div class="edit-work-order__column">
        <mat-form-field class="edit-work-order__control edit-work-order__control-address">
          <mat-label i18n="@@S_ADDRESS">Address</mat-label>
          <input matInput formControlName="address" />
        </mat-form-field>
        <mat-form-field class="edit-work-order__control edit-work-order__control-customer">
          <mat-label i18n="@@S_WORKORDEREDIT_CUSTOMER">Customer</mat-label>
          <input matInput formControlName="customer" />
        </mat-form-field>
        <mat-form-field class="edit-work-order__control edit-work-order__control-phone">
          <mat-label i18n="@@S_PHONENUMBER">Phone number</mat-label>
          <input matInput formControlName="phone" />
        </mat-form-field>
      </div>
    </div>

    <h2 i18n="@@S_WORK_ORDER_DETAILS">WORK ORDER DETAILS</h2>
    <div class="edit-work-order__fields-group">
      <div class="edit-work-order__column">
        <mat-form-field class="edit-work-order__control edit-work-order__control-reason">
          <mat-label i18n="@@S_REASON">Reason</mat-label>
          <textarea class="ds-input edit-work-order__reason" matInput formControlName="reason" cols="50" rows="5"></textarea>
        </mat-form-field>

        <mat-form-field class="edit-work-order__control edit-work-order__control-duration">
          <mat-label i18n="@@S_DURATION">Duration</mat-label>
          <div class="edit-work-order__row">
            <div class="edit-work-order__column">
              <input matInput formControlName="durationInHours" />
            </div>
            <div class="edit-work-order__column">
              <input matInput formControlName="durationInMinutes" />
            </div>
          </div>
        </mat-form-field>
      </div>
      <div class="edit-work-order__column">
        <mat-form-field class="edit-work-order__control edit-work-order__control-workorderid">
          <mat-label i18n="@@S_WORKORDEREDIT_WORKORDERID">Work Order ID</mat-label>
          <input matInput formControlName="workOrderId" />
        </mat-form-field>
        <mat-form-field class="edit-work-order__control edit-work-order__scheduleddatetime">
          <mat-label i18n="@@S_WORKORDEREDIT_SCHEDULEDDATETIME">Schedule Date and Time</mat-label>
          <input matInput formControlName="scheduledDateTime" />
        </mat-form-field>
        <mat-form-field class="edit-work-order__control edit-work-order__control-type">
          <mat-label i18n="@@S_TYPE">Type</mat-label>
          <input matInput formControlName="type" />
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div matDialogActions class="edit-work-order__actions">
  <button
    mat-button
    matDialogClose
    id="btn-tree-scoping-cancel"
    class="edit-work-order__actions__buttons__cancel btn-uppercase vzc-small"
    i18n="@@S_CANCEL"
  >
    CANCEL
  </button>
  <button
    *ngIf="(isSaving$ | async) === false"
    mat-flat-button
    color="accent"
    id="btn-tree-scoping-save"
    i18n="@@S_SAVE"
    class="edit-work-order__actions__buttons__save btn-uppercase vzc-small"
    (click)="save()"
  >
    SAVE
  </button>
  <mat-spinner diameter="28" color="accent" *ngIf="isSaving$ | async"></mat-spinner>
</div>
